import {
    apiRequest,
    userInfoDetail, 
    userInfoUpdate,
} from "../../../../../../services/adapters/master/refMesinAbsenUserInfoService"

class IndexRepository {
    fetchDetail = async (query) => {
        return await apiRequest("get", userInfoDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", userInfoUpdate, {
            body: query
        }, true)
    }

}

export default IndexRepository